export default "__VITE_ASSET__DOOXayit__"